import { Button, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Dialog } from '@app/components/dialogs'
import { useKnowledgeHubUrl } from '@app/hooks/useKnowledgeHubUrl'

type KnowledgeHubCertificateSplashScreenProps = {
  onSubmit: () => void
}

export const KnowledgeHubCertificateSplashScreen = ({
  onSubmit,
}: KnowledgeHubCertificateSplashScreenProps) => {
  const { t } = useTranslation()

  const hasDialogOpened = useRef<boolean>(false)
  const [open, setOpen] = useState(true)

  useEffect(() => {
    if (open && !hasDialogOpened.current) {
      hasDialogOpened.current = true
    }
  }, [open])

  // Record the acknowledgement once the pop-up is dismissed via the access
  // button (the only way to dismiss it) so it won't show again.
  useEffect(() => {
    if (!open && hasDialogOpened.current) {
      onSubmit()
    }
  }, [onSubmit, open])

  const knowledgeHubUrl = useKnowledgeHubUrl()

  return (
    <Dialog
      data-testid="knowledge-hub-certificate-splash-screen"
      open={open}
      // closing is only allowed via the access button.
      showClose={false}
      disableEscapeKeyDown
      onClose={() => {
        // no-op
      }}
      slots={{
        Title: () => (
          <Typography
            variant="h3"
            fontWeight={600}
            color="secondary"
            gutterBottom
            textAlign="center"
          >
            {t('components.knowledge-hub-certificate-splash-screen.title')}
          </Typography>
        ),
      }}
    >
      <Typography variant="body1" paragraph>
        <Trans
          i18nKey="components.knowledge-hub-certificate-splash-screen.body"
          components={{ b: <b />, br: <br /> }}
        />
      </Typography>

      <Button
        data-testid="knowledge-hub-certificate-splash-screen-access"
        color="lime"
        variant="contained"
        size="large"
        fullWidth
        href={knowledgeHubUrl}
        target="_blank"
        rel="noopener"
        onClick={() => {
          setOpen(false)
        }}
        sx={{ my: 2 }}
      >
        {t('components.knowledge-hub-certificate-splash-screen.access-button')}
      </Button>

      <Typography fontWeight={600}>
        {t('components.knowledge-hub-certificate-splash-screen.footer')}
      </Typography>
    </Dialog>
  )
}
